module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div id="battery-slider"><label for="battery-alert-enabled">{{ tc(\'ControlHomeAlerts\', \'Battery alert:\') }}</label><div class="input" id="battery-alert-enabled"><defa-radio-strip v-model="batterySwitchValue" :options="batterySwitchOptions" v-bind:class="{ errorState: model.batteryAlarmMask === null}" v-on:input="save($event, \'batteryAlarmMask\')"></div><dl v-show="model.modelError || model.batteryAlarmMaskError"><dd><p class="error">ERROR! {{ model.modelError || model.batteryAlarmMaskError }}</p></dd></dl></div>';
}
return __p;
};
